import React from 'react';

const AppProvider: React.FC = ({ children }) => (
  <>
    {children}
  </>
);

export default AppProvider;
